<rt-dialog-header [heading]="'tlc.members.download_credentials_dialog.heading' | translate" />
<rt-dialog-body variant="white">
  <ol>
    <li
      [innerHTML]="'tlc.members.download_credentials_dialog.description.download_file' | translate"
    ></li>
    <li
      [innerHTML]="'tlc.members.download_credentials_dialog.description.share_details' | translate"
    ></li>
  </ol>

  <rt-infobox
    [heading]="'tlc.members.download_credentials_dialog.infobox.heading' | translate"
    type="warning"
    iconName="warning"
    [isDismissible]="false"
  >
    <span>{{ 'tlc.members.download_credentials_dialog.infobox.content' | translate }}</span>
  </rt-infobox>
</rt-dialog-body>
<rt-dialog-footer>
  <rt-button variant="primary" (click)="download()">
    <rt-icon prefix name="file-download" />
    <span>{{ 'tlc.members.download_credentials_dialog.download_file' | translate }}</span>
  </rt-button>
</rt-dialog-footer>
